import { render, staticRenderFns } from "./guideUse.vue?vue&type=template&id=5347e63a&scoped=true"
import script from "./guideUse.vue?vue&type=script&lang=js"
export * from "./guideUse.vue?vue&type=script&lang=js"
import style0 from "./guideUse.vue?vue&type=style&index=0&id=5347e63a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5347e63a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5347e63a')) {
      api.createRecord('5347e63a', component.options)
    } else {
      api.reload('5347e63a', component.options)
    }
    module.hot.accept("./guideUse.vue?vue&type=template&id=5347e63a&scoped=true", function () {
      api.rerender('5347e63a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/commodityFacility/detail/guideUse.vue"
export default component.exports